import services from './services.js';
import NProgress from 'nprogress';
import Uploader from 'uploader';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import viewPhoto from 'src/common/js/viewPhoto';
import $http from '$http';
import addMatterType from '../addMatterType/index.vue'

export default {
    mixins: [services],
    components: {
        addMatterType
    },
    data() {
        return {
            dialogVisible: false,
            loading: false,
            submitFormData: this.getAddFormData(), //提交的数据
            title: '添加特殊事项',
            OATypes: [{
                'id': 1,
                'value': '是'
            }, {
                'id': 0,
                'value': '否'
            }], //是否执行OA工作流流程
            MatterTypes: [{
                'Id': 0,
                'MatterTypeName': '-请选择-'
            }],
            isChange: false,
            isExecutOACodeShow: false

        }
    },
    computed: {},
    methods: {
        getAddFormData() {
            return cloneDeep({
                "Initiator": "",
                "PickUp": "",
                "Executor": "",
                "ExecutTime": "",
                "MatterTypeId": 0,
                "IsExecutOA": 0,
                "ExecutOACode": "",
                "OrderCode": "",
                "Remark": "",
                "AttaUrl": []
            });
        },
        dialogClose() {
            this.dialogVisible = false;
            this.submitFormData = this.getAddFormData();
        },
        show(options) {
            let opts = $.extend({}, options);
            this.dialogVisible = true;
            if (opts.isChange) {
                this.title = '修改特殊事项'
                this.isChange = true
                this.getMatterData(opts.id)
            } else {
                this.title = '添加特殊事项'
                this.isChange = false
                this.submitFormData = this.getAddFormData()
            }
            this.$nextTick(() => {
                util.initUploader2(this, 'ContainerId', 'addFileBtn', (file) => {
                    this.submitFormData.AttaUrl.push(file);
                });

            });

            this.getInitData()
        },
        //是否执行OA工作流流程,为否时不显示OA工作流编号
        changeIsOA(val) {
            if (val == 0) {
                this.isExecutOACodeShow = false
            } else {
                this.isExecutOACodeShow = true
            }
        },
        // 添加事项
        addMatter() {
            this.$refs.refAddMatterType.show({});
        },
        delFile(arrList, i) {
            arrList.splice(i, 1)
        },
        // 提交数据
        submit() {
            let rules = [{
                name: "发起人",
                value: this.submitFormData.Initiator,
                required: true
            }, {
                name: "对接人",
                value: this.submitFormData.PickUp,
                required: true
            }, {
                name: "执行人",
                value: this.submitFormData.Executor,
                required: true
            }, {
                name: "执行时间",
                value: this.submitFormData.ExecutTime,
                required: true
            }, {
                name: "事项说明",
                value: this.submitFormData.Remark,
                required: true
            }];
            let flag = util.checkForm({
                ele: this,
                rules: rules
            });
            if (this.isExecutOACodeShow) {
                rules.push({
                    name: "OA工作流编号",
                    value: this.submitFormData.ExecutOACode,
                    required: true
                })
            } else {
                this.submitFormData.ExecutOACode = ''
            }
            if (!flag) {
                return;
            }

            if (this.submitFormData.MatterTypeId == 0) {
                this.$notify({
                    title: '警告',
                    message: '事项类型不能为空！',
                    type: 'warning'
                });
                return;
            }
            this.submitMatterType(this.submitFormData)
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/Memorandum/SpecialMatter/components/addSpecialMatter/vm.js